import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export let navigateOutsideReact = null;

export function NavigationBridge() {
  const navigate = useNavigate();
  useEffect(() => {
    navigateOutsideReact = navigate;
  }, [navigate]);
  return null;
}